import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { reduxForm, Field, getFormValues } from "redux-form";
import ContentCard from "../common/template/contentCard";
import ContentCardBody from "../common/template/contentCardBody";
import ContentCardFooter from "../common/template/contentCardFooter";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Button from "../common/button/button";
import Form from "../common/form/form";
import LabelAndInput from "../common/form/labelAndInput";
import LabelAndCheckbox from "../common/form/labelAndCheckbox";
import { YesNoModal } from "../common/dialog/YesNoModal.jsx";
import { setModoTela, initForm } from "./plataformaMercadoLivreActions";

class PlataformaMercadoLivreForm extends Component {
    state = {
        exibirConfirmacaoAdicionar: false,
        exibirConfirmacaoEditar: false,
    };

    onSalvarClick = () => {
        if (this.props.formularioValues.id) {
            this.setState({ exibirConfirmacaoAdicionar: false, exibirConfirmacaoEditar: true });
        } else {
            this.setState({ exibirConfirmacaoAdicionar: true, exibirConfirmacaoEditar: false });
        }
    };

    render() {
        const readOnly = this.props.visualizar;

        return (
            <>
                <YesNoModal
                    title="O registro não poderá ser excluido posteriormente, deseja realmente incluir?"
                    visible={this.state.exibirConfirmacaoAdicionar}
                    handleYes={() => {
                        this.setState({ exibirConfirmacaoAdicionar: false, exibirConfirmacaoEditar: false });
                        this.props.handleSubmit(this.props.onSubmit)();
                    }}
                    handleNo={() => {
                        this.setState({ exibirConfirmacaoAdicionar: false, exibirConfirmacaoEditar: false });
                    }}
                />
                <YesNoModal
                    title="A alteração pode afetar os campos exibidos no cadastro da UC, deseja continuar?"
                    visible={this.state.exibirConfirmacaoEditar}
                    handleYes={() => {
                        this.setState({ exibirConfirmacaoEditar: false, exibirConfirmacaoAdicionar: false });
                        this.props.handleSubmit(this.props.onSubmit)();
                    }}
                    handleNo={() => {
                        this.setState({ exibirConfirmacaoEditar: false, exibirConfirmacaoAdicionar: false });
                    }}
                />
                <ContentCard>
                    <Form event={this.props.handleSubmit}>
                        <Row>
                            <Grid cols="12 12 6 6">
                                <ContentCardBody>
                                    <Row>
                                        <Field name="nome" component={LabelAndInput} label="Nome" placeholder="Informe o nome" cols="12 12 12 12" readOnly={readOnly} />
                                    </Row>
                                    <Row>
                                        <Field name="integracao_por_email" component={LabelAndCheckbox} label="Integração por E-mail" cols="12 12 12 12" readOnly={readOnly} />
                                    </Row>
                                </ContentCardBody>
                            </Grid>
                        </Row>
                        <ContentCardFooter>
                            <Row alignCenter>
                                <Grid cols="6 6 4 3">
                                    <Button
                                        text={"Salvar"}
                                        event={this.onSalvarClick}
                                        type={"success"}
                                        icon={"fa fa-check"}
                                        disabled={
                                            !(
                                                this.props.usuarioLogado.acesso_plataforma_mercado_livre_adicionar ||
                                                this.props.usuarioLogado.acesso_plataforma_mercado_livre_editar
                                            ) || this.props.visualizar
                                        }
                                    />
                                </Grid>
                                <Grid cols="6 6 4 3">
                                    <Button text="Voltar" type={"warning"} icon={"fa fa-chevron-left"} event={() => this.props.setModoTela("lista")} />
                                </Grid>
                            </Row>
                        </ContentCardFooter>
                    </Form>
                </ContentCard>
            </>
        );
    }
}

PlataformaMercadoLivreForm = reduxForm({
    form: "plataformaMercadoLivreForm",
    destroyOnUnmount: false,
})(PlataformaMercadoLivreForm);
const mapStateToProps = (state) => ({
    sessao: state.auth.usuario,
    usuarioLogado: state.auth.usuarioLogado,
    formularioValues: getFormValues("plataformaMercadoLivreForm")(state),
    registro: state.plataformaMercadoLivre.registro,
    lista: state.plataformaMercadoLivre.lista,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(PlataformaMercadoLivreForm);
